import LegalViewPage from "./LegalViewPage";

export default LegalViewPage